import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import './footer.css';
// deixa de ser burro e troca esse ano por algo dinâmico
import pt from '../../locales/pt.json'

const getCurrentYear = () => new Date().getFullYear();

const Footer = () => {

  return (
    <div className="footer-box">
      <AnimationOnScroll animateIn="slide-in-fwd-bottom" offset={1250} duration={0.7} delay={300}>
        <footer className="psico__footer">
          <div className="psico__footer-content">
            <p>©{getCurrentYear()}, {pt.footer.psico} – {pt.footer.direitos} |</p>
            <p><a href="mailto:guilhermesantosdegodoy@gmail.com">{pt.footer.dev}</a></p>
          </div>

          <div className="psico__footer-content__broken">
            <p>©{getCurrentYear()}, {pt.footer.psico} –</p>
            <p>{pt.footer.direitos} |</p>
            <a href="mailto:guilhermesantosdegodoy@gmail.com">{pt.footer.dev}</a>
          </div>

          <div className="psico__footer-content__brokenMiddle">
            <p>©{getCurrentYear()}, {pt.footer.psico} – {pt.footer.direitos} |</p>
            <p><a href="mailto:guilhermesantosdegodoy@gmail.com">{pt.footer.dev}</a></p>
          </div>
        </footer>
      </AnimationOnScroll>
    </div>
  );
};

export default Footer;
